export class ObjectUtils {

    public static deepAssign<T extends Object, S extends Object>(dest: T, src: S): T & S {
        if (<any>dest === src) {
            return <any>dest;
        }
        for (const key in src) {
            if (!src.hasOwnProperty(key)) {
                continue;
            }
            const srcVal = src[key];
            if (dest.hasOwnProperty(key)) {
                const destVal = (<any>dest)[key];
                if (ObjectUtils.isObject(destVal) && ObjectUtils.isObject(srcVal)) {
                    ObjectUtils.deepAssign(destVal, srcVal);
                } else {
                    (<any>dest)[key] = srcVal;
                }
            } else {
                (<any>dest)[key] = srcVal;
            }
        }
        return <any>dest;
    }

    public static isObject<T>(x: T | undefined | null | boolean | string | symbol | number): x is T {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }
}
